<script setup lang="ts">
import type { UIMessage } from 'ai'

const props = defineProps<{
  message: UIMessage
  showResendButton?: boolean
}>()

const emit = defineEmits<{
  messageRegenerateRequested: []
}>()

const { t } = useI18n()

const texts = computed(() => props.message.parts.filter(part => part.type === 'text').map(part => part.text).join(''))
</script>

<template>
  <article class="w-full max-w-full scroll-mt-4 pb-9 sm:scroll-mt-10">
    <div class="ms-auto flex w-fit max-w-[75%] flex-col items-end gap-1">
      <div class="rounded-md bg-blue-100 p-2.5 text-sm">
        {{ texts }}
      </div>

      <DTButton
        v-if="showResendButton"
        size="xs"
        variant="link"
        dense
        @click="emit('messageRegenerateRequested')"
      >
        {{ t('resend') }}
      </DTButton>
    </div>
  </article>
</template>
